import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { List } from 'immutable';

import { Field } from 'redux-form/immutable';
import * as validations from 'modules/forms/validations';
import { SelectFieldF } from 'modules/forms/component';

import * as reservasActions from '../action';
import * as viajesActions from 'modules/viajes/action';
import * as trayectosActions from 'modules/trayectos/action';
import { listFindByMapId, checkPermissions, pickAColor } from 'core/generalFunctions';

@connect((store) => ({
  viajes: store.get('viajes'),
  viaje: store.getIn(['reservas', 'viaje']),
  trayectos: store.getIn(['trayectos', 'lista']),
}))
class SelectViaje extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      diaViaje: null,
      trayectoId: null,
    };
  }
  componentDidMount() {
    const { viajes, trayectos, dispatch } = this.props;
    (viajes.get('hoy').size == 0 || viajes.get('manana').size == 0) &&
      checkPermissions(['devAdmin', 'administrador_viajes', 'ver_viajes', 'administrador_reservas']) &&
      this.props.dispatch(viajesActions.get());
    if (trayectos.size == 0) dispatch(trayectosActions.get());
  }
  componentDidUpdate = () => {
    const { viaje } = this.props;
    if (viaje.size > 0 && !this.state.diaViaje) {
      this.initState(viaje);
    }
  };
  initState(viajeSelected) {
    const horario = viajeSelected.get('horario');
    this.setState({ trayectoId: viajeSelected.get('trayectoId') });
    if (horario) {
      let diff = moment().startOf('day').diff(horario, 'days');
      if (diff === 0) this.setState({ diaViaje: 'hoy' });
      else if (diff === -1) this.setState({ diaViaje: 'manana' });
      else this.setState({ diaViaje: 'buscado' });
    }
  }
  componentWillUnmount = () => {
    //this.props.dispatch(reservasActions.clear('all'));
    this.props.dispatch(viajesActions.clear('viaje'));
  };
  changeDiaViaje = (e, val, dia) => {
    if (dia === 'buscado') this.datePicker.focus();
    this.setState({ diaViaje: dia });
    this.props.change('viajeId', null);
  };
  dialogBuscar = (e, diaViaje) => this.props.dispatch(viajesActions.buscar(diaViaje));
  setViajeState = (e, viajeId) => {
    const { dispatch, viajes, change } = this.props;
    const viaje = listFindByMapId(viajes.get(this.state.diaViaje), viajeId);
    dispatch(reservasActions.setState({ viaje }));
  };
  changeTrayecto = (trayectoId) => {
    this.setState({ trayectoId });
    this.props.change('viajeId', null);
    this.props.dispatch(trayectosActions.getParadas(trayectoId, undefined, undefined, ['FORM_RESERVAparadaSubida', 'FORM_RESERVAparadaBajada']));
  };
  render() {
    const listaViajes = (this.props.viajes.get(this.state.diaViaje) || List()).toJS(),
      { diaViaje, trayectoId } = this.state;
    return (
      <div>
        <MaterialUI.SelectField name="trayectoId" required fullWidth={true} floatingLabelText="Trayecto" onChange={(e, val, trayectoId) => this.changeTrayecto(trayectoId)} value={trayectoId}>
          {this.props.trayectos.map((trayecto) => (
            <MaterialUI.MenuItem
              key={trayecto.get('id')}
              value={trayecto.get('id')}
              primaryText={trayecto.get('subnombre') ? trayecto.get('nombre') + ' - ' + trayecto.get('subnombre') : trayecto.get('nombre')}
              style={{ color: pickAColor(trayecto.get('id')) }}
            />
          ))}
        </MaterialUI.SelectField>
        <MaterialUI.SelectField name="diaViaje" required fullWidth={true} floatingLabelText="Dia viaje" hintText="Dia viaje" onChange={this.changeDiaViaje} value={diaViaje}>
          <MaterialUI.MenuItem value={'hoy'} primaryText="Hoy" />
          <MaterialUI.MenuItem value={'manana'} primaryText="Manana" />
          <MaterialUI.MenuItem value={'buscado'} primaryText="Otro" />
        </MaterialUI.SelectField>
        <Field
          name="viajeId"
          component={SelectFieldF}
          inputProps={{
            fullWidth: true,
            hintText: 'Viaje',
            floatingLabelText: 'Viaje',
            maxHeight: 300,
          }}
          validate={validations.required}
          onChange={this.setViajeState.bind(this)}
        >
          {listaViajes
            .filter((v) => v.trayectoId == trayectoId)
            .map((viaje) => (
              <MaterialUI.MenuItem key={viaje.id} value={viaje.id} primaryText={moment(viaje.horario).format('HH:mm - DD/MM')} style={{ color: pickAColor(viaje.trayectoId) }} />
            ))}
        </Field>
        <div className="hidden">
          <MaterialUI.DatePicker
            autoOk
            fullWidth
            className="pt-25"
            floatingLabelText="Dia"
            hintText="Seleccione un dia"
            onChange={this.dialogBuscar.bind(this)}
            ref={(input) => {
              this.datePicker = input;
            }}
          />
        </div>
      </div>
    );
  }
}

SelectViaje.propTypes = {
  change: PropTypes.func.isRequired, // Change de redux-form
};

export default SelectViaje;



// WEBPACK FOOTER //
// src/modules/reservas/components/selectViaje.js